import React from 'react';
import { useTimeoutToggle } from '@/hooks';

import styled from 'styled-components';
import { TrevorComponent, TrevorIcon } from '@trevor/ui-components';
import CopiedNotification from '@/features/publicDatasets/publicdatasets/PublicDatasetsTopPanel/Social/CopiedNotification';

const ShareChain = styled(TrevorIcon).attrs({
  name: 'share-chain',
  size: 23,
})`
  position: absolute;
  cursor: pointer;
  right: 5px;
  top: 4px;
`;

const CopyUrlButton: TrevorComponent<{ url: string }> = ({
  className,
  url,
}) => {
  const [isNotificationShown, showNotification, closeNotification] =
    useTimeoutToggle(2500);

  const copy = () => {
    showNotification();
    window.navigator.clipboard.writeText(url);
  };

  return (
    <div className={className}>
      <input type="text" value={url} readOnly />
      <ShareChain onClick={copy} />
      <CopiedNotification
        onClose={closeNotification}
        $isShown={isNotificationShown}
      />
    </div>
  );
};

export default styled(CopyUrlButton)`
  position: relative;
  width: 333px;
  border-radius: 20px;
  border: 1px solid #cccccc;
  padding: 5.5px 38px 5.5px 18px;

  input {
    height: 20px;
    line-height: 20px;
    border: none;
    outline: none;
    width: 100%;
    font-size: 13px;
  }
`;
